/**
 * Do not edit directly, this file was auto-generated.
 */

import { css } from 'styled-components';
export const cssVariables = css`
  --mlb-1-brand-background-main: #333333;
  --mlb-1-brand-background-support: #282828;
  --mlb-1-brand-background-inverse: #ffffff;
  --mlb-1-brand-text-primary: #ffffff;
  --mlb-1-brand-text-secondary: rgba(255, 255, 255, 0.8);
  --mlb-1-brand-text-inverse: #333333;
  --mlb-1-brand-icon-primary: #ffffff;
  --mlb-1-brand-icon-inverse: #333333;
  --mlb-1-brand-border-decorative: #282828;
  --mlb-1-brand-border-contrast: #606060;
  --mlb-1-brand-border-inverse: #ffffff;
  --mlb-1-brand-decorative-color-1: #333333;
  --mlb-1-brand-decorative-color-2: #000000;
  --mlb-1-brand-surface: #333333;
`;
export const theme = {
  'brand/background/main': 'var(--mlb-1-brand-background-main)',
  'brand/background/support': 'var(--mlb-1-brand-background-support)',
  'brand/background/inverse': 'var(--mlb-1-brand-background-inverse)',
  'brand/text/primary': 'var(--mlb-1-brand-text-primary)',
  'brand/text/secondary': 'var(--mlb-1-brand-text-secondary)',
  'brand/text/inverse': 'var(--mlb-1-brand-text-inverse)',
  'brand/icon/primary': 'var(--mlb-1-brand-icon-primary)',
  'brand/icon/inverse': 'var(--mlb-1-brand-icon-inverse)',
  'brand/border/decorative': 'var(--mlb-1-brand-border-decorative)',
  'brand/border/contrast': 'var(--mlb-1-brand-border-contrast)',
  'brand/border/inverse': 'var(--mlb-1-brand-border-inverse)',
  'brand/decorative/color-1': 'var(--mlb-1-brand-decorative-color-1)',
  'brand/decorative/color-2': 'var(--mlb-1-brand-decorative-color-2)',
  'brand/surface': 'var(--mlb-1-brand-surface)',
};
